module.exports = __webpack_public_path__ + "img/partners-id.712b86e.png";